import { execute } from '@/api/execute'
import { GET } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

import animalfeed from './animalfeed'
import inout from './inout'
import load from './load'
import planfeed from './planfeed'
import upload from './upload'
import inoutnew from './inoutnew'
import {LANG_VAR_LOCAL_STORAGE_KEY} from '@/util/consts'

const ENDPOINT = 'report'

export default {
  /**
   * Fetchs report types list from server
   * @param {*} query params
   * @returns server response
   */
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/list/`, params))
  },

  make (link, params = {}) {
    params = {...params, language: localStorage.getItem(LANG_VAR_LOCAL_STORAGE_KEY)}
    return execute(GET, addQueryParams(`${ENDPOINT}/${link}/make/`, params))
  },

  animalfeed,
  inout,
  inoutnew,
  load,
  planfeed,
  upload
}
